import React from 'react';
import CategoryItem from './CategoryItem';
import { useSelector } from 'react-redux';

const CategorySectionContainer = () => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);

    return <CategoryItem links={contentLinks} />;
};

export default CategorySectionContainer;
